/**
 * NORM-009 — rangos de magnitud |FP| (NTCO-PMGD: 0,95 ind. – 0,96 cap.; Netbilling EG: 0,95 – 0,95).
 * OpenDSS / UI: magnitud con inductivo o capacitivo según naturaleza; aquí solo los extremos permitidos.
 */

export const FP_MIN_INDUCTIVO = 0.95;
/** Tope adelanto capacitivo PMGD (Art. 3-19 / 3-31). */
export const FP_TOPE_CAPACITIVO_PMGD = 0.96;
/** Tope adelanto capacitivo EG (Art. 5-18 / 5-19). */
export const FP_TOPE_CAPACITIVO_EG = 0.95;

export type TipoGdFp = 'PMGD' | 'EG';

/**
 * Rango del slider de magnitud |FP| según tipo de instalación y naturaleza.
 * - Inductivo: [0,95, 1,0] (mínimo atraso admitido → unidad).
 * - Capacitivo PMGD: [0,96, 1,0] (máximo adelanto 0,96 → unidad).
 * - Capacitivo EG: [0,95, 1,0].
 */
export function fpMagnitudSliderBounds(
  tipoGd: TipoGdFp,
  naturaleza: 'inductivo' | 'capacitivo'
): { min: number; max: number } {
  if (naturaleza === 'inductivo') {
    return { min: FP_MIN_INDUCTIVO, max: 1.0 };
  }
  const minCap = tipoGd === 'PMGD' ? FP_TOPE_CAPACITIVO_PMGD : FP_TOPE_CAPACITIVO_EG;
  return { min: minCap, max: 1.0 };
}

export function clampFpMagnitud(
  value: number,
  tipoGd: TipoGdFp,
  naturaleza: 'inductivo' | 'capacitivo'
): number {
  const { min, max } = fpMagnitudSliderBounds(tipoGd, naturaleza);
  return Math.min(max, Math.max(min, value));
}
